import { render, staticRenderFns } from "./customGoods.module.vue?vue&type=template&id=73f0d7a6&scoped=true"
import script from "./customGoods.module.vue?vue&type=script&lang=js"
export * from "./customGoods.module.vue?vue&type=script&lang=js"
import style0 from "./customGoods.module.vue?vue&type=style&index=0&id=73f0d7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0d7a6",
  null
  
)

export default component.exports